import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  successResponse: [],
  isLoading: false,
  hasData: false,
  isError: false,
  error: ""
};
const tripWeatherInfoSlice = createSlice({
  name: "tripWeatherInfoSlice",
  initialState,
  reducers: {
    weatherFromDataRequest: (state, action) => {
      state.isLoading = true;
      state.error = "";
    },
    weatherFromDataSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.successResponse = state?.successResponse?.concat(action?.payload);
    },
    weatherFromDataFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.isError = true;
    },
    singleWeatherFromDataRequest: (state, action) => {
      state.isLoading = true;
      state.error = "";
    },
    singleWeatherFromDataSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.successResponse = [action.payload, ...state.successResponse];
    },
    singleWeatherFromDataFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.isError = true;
    }
  }
});
export const {
  weatherFromDataRequest,
  weatherFromDataSuccess,
  weatherFromDataFailure,
  singleWeatherFromDataRequest,
  singleWeatherFromDataSuccess,
  singleWeatherFromDataFailure
} = tripWeatherInfoSlice.actions;
export default tripWeatherInfoSlice.reducer;